<template>
    <cusPopup v-model:showBoo="showModalBoo" :closeOnClickOverlay="false">
        <view class="cusModal">
            <view class="titles" v-if="title">
                {{ title }}
            </view>
            <slot>
                <view class="content" v-if="content">
                    {{ content }}
                </view>
            </slot>
            <view class="btn">
                <view class="cancle sub-btn" @click="cancle">取消</view>
                <view class="chat sub-btn" @click="confirm">确定</view>
            </view>
        </view>
    </cusPopup>
</template>

<script setup>
    import { ref, watch } from 'vue';
    import { usePublicStore } from '@/stores/public';
    const $props = defineProps({
        zIndex: {
            type: [Number, String],
            default: 10076
        },
        width: {
            type: String,
            default: '480px'
        },
        showBoo: {
            type: Boolean,
            default: false
        },
        content: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: '提示'
        },
        callBackFun: {
            type: Function
        },
        closeOnClickOverlay: {
            type: Boolean,
            default: true
        }
    });
    const showModalBoo = ref(false);
    watch(
        () => $props.showBoo,
        () => {
            if ($props.showBoo) {
                return openModal();
            }
            closeModal();
        },
        { deep: true }
    );
    const $emits = defineEmits(['update:showBoo', 'confirm', 'close']);
    const openModal = () => {
        usePublicStore().setPageScorll(true);
        showModalBoo.value = true;
    };
    const closeModal = () => {
        showModalBoo.value = false;
        $emits('update:showBoo', false);
    };
    const cancle = () => {
        usePublicStore().setPageScorll(false);
        showModalBoo.value = false;
        $emits('update:showBoo', false);
        $emits('close');
    };
    const confirm = () => {
        usePublicStore().setPageScorll(false);
        if (typeof $props.callBackFun == 'function') {
            return $props.callBackFun();
        } else {
            showModalBoo.value = false;
            $emits('confirm');
            $emits('update:showBoo', false);
        }
    };
</script>

<style lang="scss" scoped>
    :deep(.uv-line) {
        display: none;
    }
    :deep(.uv-modal__content) {
        background-color: #fff !important;
    }
    .cusModal {
        background-color: #fff !important;
        padding: 25px;
        .titles {
            font-size: 40rpx;
            color: #4f5767;
            font-weight: 600;
            margin-bottom: 30px;
            display: block;
            text-align: center;
            font-size: 26px;
        }
        .content {
            font-size: 24px;
            margin: 30px 20px;
            text-align: center;
        }
        .btn {
            display: flex;
            justify-content: space-around;
            padding-bottom: 10px;
            width: 100%;
            view {
                flex: 1;
                font-size: 24px;
                white-space: nowrap;
                padding: 0px 65px;
                color: #fff;
                margin: 0 20px;
                border: 1px solid transparent;
            }
            .cancle {
                border-color: #828282;
                background: transparent;
                color: #828282;
            }
            .chat {
                // background: $btn-color;
            }
        }
    }
</style>
